import React from 'react'
import { NavLink, generatePath, useLocation, matchPath } from 'react-router-dom'

import { Tooltip } from '@caudena/core/ui-kit'
import { Text } from '@caudena/core/ui-kit'
import { NavItem as NavItemType, RouterParams } from '../../state'

import NavItemCounter from './Counter'
import NavLinkIcon from './NavLinkIcon'

import styles from './index.scss'
import classnames from 'classnames/bind'

const cx = classnames.bind(styles)

interface NavItemProps {
  className?: string
  item: NavItemType
  isOpen: boolean
  params?: RouterParams
}

const NavItem: React.FC<NavItemProps> = ({
  item,
  params,
  isOpen,
  className,
}) => {
  const location = useLocation()
  const url = item.to ? generatePath(item.to, params) : null

  const isActive = React.useMemo(() => {
    if (!item.to) return false
    return !!matchPath({ path: item.to, end: false }, location.pathname)
  }, [item.to, location.pathname])

  const linkContent = (
    <>
      <NavLinkIcon className={cx('NavItemIcon')} icon={item.icon} />
      <Text className={cx('NavItemLabel')}>{item.label}</Text>
      <NavItemCounter className={cx('NavItemCounter')} url={item.counterUrl} />
    </>
  )

  return (
    <li className={cx('NavItem', className)}>
      <Tooltip content={isOpen ? '' : item.label} placement="right">
        <NavLink
          className={({ isActive: navLinkIsActive }) =>
            isActive || navLinkIsActive
              ? cx('NavItemLink', 'active', {
                  disabled: item.disabled || !url,
                })
              : cx('NavItemLink', { disabled: item.disabled || !url })
          }
          to={url ?? ''}
        >
          {linkContent}
        </NavLink>
      </Tooltip>
    </li>
  )
}

export default NavItem
